<ng-container *ngIf="!!get">
    <div class="tt-calc-copy-from__form">
        <tt-card>
            <tt-input ttLabel="cust_no" [ttModel]="get.cust_no" ttReadonly></tt-input>
            <tt-search ttLabel="cust_name" [(ttModel)]="get.cust_name" [ttSearch]="searchCustomer" (ttOnSelected)="onCustomerSelected($event)" (ttOnClear)="onCustomerSelected()"></tt-search>
        </tt-card>
        <tt-card>
            <tt-input ttLabel="calc_keyno_copy_from" [ttModel]="get.calc_keyno_copy_from" ttReadonly></tt-input>
            <tt-button-save
                ttText="calc_copy_from_save"
                ttIcon="fas fa-clone"
                (ttClick)="copyFromSelectedRow()"
                [ttLoading]="saving"
                [ttDisabled]="'' + get.calc_keyno_copy_from === '0'"
            ></tt-button-save>
        </tt-card>
        <tt-card></tt-card>
    </div>
    <tt-grid class="flex-1" style="min-height: 300px" *ngIf="grid" [(ttOptions)]="grid" (ttOnRowSelected)="onRowSelected($event)"></tt-grid>
</ng-container>

<!-- parameter: {{ params | json }} <br />
get: {{ get | json }} -->
